import { Component, Input, OnInit } from '@angular/core';
import { Order, OrderDTO } from '@app/data-interfaces';

@Component({
  selector: 'ui-order-detail',
  templateUrl: './ui-order-detail.component.html',
  styleUrls: ['./ui-order-detail.component.scss'],
})
export class UiOrderDetailComponent implements OnInit {
  @Input()
  order?: Order | undefined;
  @Input() orderDTO?: OrderDTO | undefined;
  constructor() {}

  ngOnInit(): void {}
}
